export default __webpack_public_path__ + "static/media/culture_EP17.1ad0c9c5.png";